"use client";

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { motion } from "framer-motion";
import { PhosphorIcon } from "@/components/marketing/PhosphorIcon";
import type { IFeatureItem } from "@/lib/sanity/types";
import { marketingMotion } from "@/lib/motion/config";

interface IFeaturesGridProps {
  features: IFeatureItem[];
  columns?: 2 | 3;
}

const gridCols: Record<number, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
};

export function FeaturesGrid({
  features,
  columns = 3,
}: IFeaturesGridProps): React.ReactElement {
  return (
    <div className={`grid gap-6 ${gridCols[columns]}`}>
      {features.map((item) => (
        <motion.div
          key={item._key}
          initial={{ opacity: 0, y: 14, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={marketingMotion.viewport}
          transition={{ duration: marketingMotion.duration.base }}
          whileHover={{ y: -4 }}
        >
        <Card className="transition-shadow duration-200 hover:shadow-md">
          <CardHeader>
            {item.icon && (
              <PhosphorIcon
                name={item.icon}
                className="mb-2 h-8 w-8 text-primary"
              />
            )}
            <CardTitle className="text-lg">{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </CardHeader>
        </Card>
        </motion.div>
      ))}
    </div>
  );
}
